(function() {
    'use strict';

    angular.module('app.sso', [
        'app.core'
      ]);
})();